var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { appointmentStatuses } from 'constants/appointmentStatus';
import { MissedAppointment } from 'shared/assets/icons/MissedAppointment';
import { Flex, Icon, Tooltip } from 'shared/components/ui';
/**
Make Icon that allows it to be so
I can view my no-show notes and late cancellation notes in my list of signed notes.
I can view the saved note in the to do
I can identify the type of signed note before opening the note.

 */
var NoShowIndicator = function (_a) {
    var showStatus = _a.showStatus;
    var noshowstatus = showStatus ? appointmentStatuses[showStatus] : undefined;
    return (_jsx(Tooltip, __assign({ label: noshowstatus, "aria-label": "NoShowIndicator", hasArrow: true }, { children: _jsx(Flex, __assign({ as: "span", alignItems: "center" }, { children: _jsx(Icon, { as: MissedAppointment, boxSize: 4, mr: 1, color: "platform.dark" }) })) })));
};
export { NoShowIndicator };
